import type { Theme } from "@mui/system";
import { FulfilmentStatus } from "../core/api/use-get-fulfilment-detail/FulfilmentStatus";
import { ActivityStatus } from "../core/dtos/ActivityStatus";

type VaporColors =
    | "blueSapphire"
    | "islamicGreen"
    | "russianViolet"
    | "maximumPurple"
    | "mediumSlateBlue"
    | "prune"
    | "royalFuchsia"
    | "rustyRed";

export const getActivityColorFromStatus = (
    status: ActivityStatus,
): VaporColors => {
    switch (status) {
        case ActivityStatus.LINKED:
            return "royalFuchsia";
        case ActivityStatus.PENDING:
            return "mediumSlateBlue";
        case ActivityStatus.CLOSED:
            return "blueSapphire";
        case ActivityStatus.COMPLETED:
            return "islamicGreen";
        default:
            return "blueSapphire";
    }
};

export const getFulfilmentColorAndVariantByStatus = (
    status: FulfilmentStatus,
    theme: Theme,
) => {
    const variant: "ghost" | "default" | "standard" = "ghost";
    let themeColor: string;
    let vaporColor: VaporColors;

    switch (status) {
        case FulfilmentStatus.LINKED:
            themeColor = theme.palette.primary.accentRoyalFuchsia;
            vaporColor = "royalFuchsia";
            break;
        case FulfilmentStatus.PENDING:
            themeColor = theme.palette.primary.accentMediumSlateBlue;
            vaporColor = "mediumSlateBlue";
            break;
        case FulfilmentStatus.CLOSED:
            themeColor = theme.palette.primary.accentBlueSapphire;
            vaporColor = "blueSapphire";
            break;
        case FulfilmentStatus.COMPLETED:
            themeColor = theme.palette.primary.accentIslamicGreen;
            vaporColor = "islamicGreen";
            break;
        default:
            themeColor = theme.palette.primary.accentBlueSapphire;
            vaporColor = "blueSapphire";
            break;
    }

    return {
        themeColor,
        vaporColor,
        variant,
    };
};
